import React from "react";
import "../styles/Nav.css";
import logo from "../images/logo_sc.png";
export default class Nav extends React.Component{
    render() {
        return (
            <nav>
                <div className="section"></div>
                <div className="section">
                    <img src={logo} alt=""/>
                </div>
                <div className="section"></div>
            </nav>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Nav.js